module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminampa-informacion/adminampa-informacion.component.scss
// module id = ./src/app/adminampa-informacion/adminampa-informacion.component.scss
// module chunks = main